import * as u from './utils';

export default () => {
    const container = document.querySelector('.js-load-more-items');

    if (!container) {
        return;
    }

    const button = document.querySelector('.js-load-more-trigger');
    const paginationEvent = new Event('blog-pagination-complete', {
        /*'bubbles': true*/
    });
    const counter = document.querySelector('.js-load-more-showing');

    let currentPage = parseInt(button.dataset.current, 10);
    const totalPages = parseInt(button.dataset.total, 10);

    const loadMore = () => {
        if (currentPage >= totalPages) {
            return false;
        }

        // Stop repeated submissions
        if (u.hasClass(container, 'is-loading')) {
            return false;
        }
        u.addClass(container, 'is-loading');
        u.addClass(button, 'inactive');
        currentPage++;

        // Load new content
        const data = new FormData();
        data.append('action', 'js_load_posts');
        data.append('security', WP.nonce);
        data.append('term', container.getAttribute('data-term'));
        data.append('paged', currentPage);

        fetch(WP.ajax, {
            method: 'POST',
            body: data,
        })
            .then((response) => {
                return response.text();
            })
            .then((html) => {
                if (html) {
                    container.insertAdjacentHTML('beforeend', html);

                    const currentNumber = parseInt(counter.textContent, 10);
                    counter.textContent = currentNumber + document.querySelectorAll('[data-appended]').length;

                    document.dispatchEvent(paginationEvent);

                    if (currentPage < totalPages) {
                        u.removeClass(button, 'inactive');
                    }
                }
            })
            .catch((err) => {
                console.warn('Something went wrong.', err); // eslint-disable-line no-console
            });

        // Reset variables for next load
        u.removeClass(container, 'is-loading');
    };

    button.addEventListener('click', loadMore);
};
